import { cn as i } from "../../../lib/utils.es.js";
import { jsx as t } from "react/jsx-runtime";
import * as r from "@radix-ui/react-popover";
var p = (o) => /* @__PURE__ */ t(r.Root, {
  "data-slot": "popover",
  ...o
}), s = (o) => /* @__PURE__ */ t(r.Trigger, {
  "data-slot": "popover-trigger",
  ...o
}), b = ({ className: o, align: e = "center", sideOffset: a = 4, ...l }) => /* @__PURE__ */ t(r.Portal, { children: /* @__PURE__ */ t(r.Content, {
  align: e,
  className: i("lib:data-[side=bottom]:slide-in-from-top-2 lib:data-[side=left]:slide-in-from-right-2 lib:data-[side=right]:slide-in-from-left-2 lib:data-[side=top]:slide-in-from-bottom-2 lib:data-[state=open]:fade-in-0 lib:data-[state=open]:zoom-in-95 lib:data-[state=closed]:fade-out-0 lib:data-[state=closed]:zoom-out-95 lib:z-50 lib:flex lib:w-72 lib:origin-(--radix-popover-content-transform-origin) lib:flex-col lib:gap-2.5 lib:rounded-lg lib:bg-popover lib:p-2.5 lib:text-popover-foreground lib:text-sm lib:shadow-md lib:outline-hidden lib:ring-1 lib:ring-foreground/10 lib:duration-100 lib:data-[state=closed]:animate-out lib:data-[state=open]:animate-in", o),
  "data-slot": "popover-content",
  sideOffset: a,
  ...l
}) }), m = (o) => /* @__PURE__ */ t(r.Anchor, {
  "data-slot": "popover-anchor",
  ...o
}), v = ({ className: o, ...e }) => /* @__PURE__ */ t("div", {
  className: i("lib:flex lib:flex-col lib:gap-0.5 lib:text-sm", o),
  "data-slot": "popover-header",
  ...e
}), f = ({ className: o, ...e }) => /* @__PURE__ */ t("div", {
  className: i("cn-font-heading lib:font-medium", o),
  "data-slot": "popover-title",
  ...e
}), c = ({ className: o, ...e }) => /* @__PURE__ */ t("p", {
  className: i("lib:text-muted-foreground", o),
  "data-slot": "popover-description",
  ...e
});
export {
  p as Popover,
  m as PopoverAnchor,
  b as PopoverContent,
  c as PopoverDescription,
  v as PopoverHeader,
  f as PopoverTitle,
  s as PopoverTrigger
};
